"use client";
import { useModal } from "@/stores/use-modal-store";
import { Text } from "@/components/ui/text";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { ManualUpload } from "@/components/invite/manual-upload";
import { BulkUpload } from "@/components/invite/bulk-upload";
import { ShareLink } from "@/components/invite/share-link";
import { useParams, usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useMemo } from "react";
import { X } from "lucide-react";
import { useMemberQuery } from "@/hooks/use-member-query";
import { Button } from "@/components/ui/button";
import { useUserQuery } from "@/hooks/use-user-query";

export const ExportConfirmationModal = () => {
  const { isOpen, type, onClose } = useModal();
  const { data } = useUserQuery({ userId: "me" });

  const isModalOpen = useMemo(() => {
    return isOpen && type === "exportConfirmation";
  }, [isOpen, type]);

  const handleClose = () => onClose();

  return (
    <Dialog open={isModalOpen} onOpenChange={handleClose}>
      <DialogContent
        className="max-w-full-50px w-[370px] overflow-hidden p-0 bg-none border-none backdrop-blur-none shadow-none"
        style={{
          height: "calc(100dvh - 90px)",
          background: "transparent"
        }}
        isShowCloseBtn={false}
      >
        <div className="w-full max-h-full flex flex-col overflow-hidden">
          <div className="rounded-lg  bg-modal overflow-hidden py-4 shadow-lg backdrop-blur-20 flex flex-col my-auto">
            <div className="flex-shrink-0 px-4">
              <DialogHeader className="flex-shrink-0 ">
                <div className="flex ">
                  <DialogTitle className="text-[1.125rem]">Export in progress!</DialogTitle>
                  <DialogClose className="ms-auto">
                    <X className="h-4 w-4" />
                  </DialogClose>
                </div>
              </DialogHeader>
            </div>
            <Text className="text-[#707070] px-4 text-[1rem] mt-2">
              The file will be sent shortly to your registered email:{" "}
              <span className="text-black">{data?.email}</span>
            </Text>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
